<template>
    <div>
        <div style="height:40px;line-height:40px;text-align:center;font-size:14px;color:#409eff;font-weight:600;background:#fff;border-bottom:2px solid #389">
            <i class="iconfont icon-zcpt-xiaoshouguanli" style="font-size:18px;margin-right:10px;color:#409eff"></i>销售流程导航 
        </div>
        <div style="height:92vh;overflow-y:hidden">
            <FlowDesigner 
                    class="flow-chart-readonly" 
                    ref="menuFlowDesigner" 
                    v-model="flowData" 
                    :viewer="isRouterView" 
                    :allowedRoutes="menuList"
                    @node-click="handleNodeClick">
            </FlowDesigner>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag  :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import FlowDesigner from "@/components/FlowDesigner/index.vue";
import menuFlowDefineService from '@/components/FlowDesigner/menuFlowDefineService'
    export default {
        name:'ord_chart',
        data () {
            return {
                v_idseq :this.$cookies.get('v_idseq'),
                v_url:this.$store.state.loginUrl , //api请求路径      
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                isRouterView:true,
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                promptWin:false,
                prompt:'',  
                flowData:{}, 
                menuList:[],
            }
        },
        created () {
            this.getMenuList()
        },
        components: {
 
            FlowDesigner,
 
        },
        mounted(){
             this.loadMenuFlow('474963')
             
        },
        computed: {
            tabWidth: function() {
                return (window.innerWidth - 200) + 'px';
            }, 
            tabHeight: function() {
                return (window.innerHeight - 115) + 'px';
            }, 
        },
        methods: {
            getMenuList(){
                this.menuList =[]
             //用户菜单
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_table:'V_SYS_ROLE_USER',p_key:'USERID',p_value:this.v_idseq,p_key2:'stfg',p_value2:'Y',p_key3:'corpid',p_value3:this.v_corpid},
                }).then(res=>{
                    let v_idseq =res.result[0]['IDSEQ']
                    this.$axios({
                        method:'post',
                        url: 'xuper_auth/getUserMenu' ,
                        data:{ p_idseq :v_idseq,p_cond:' and isfront=\'N\''},
                    }).then(res =>{
                        if(res.code==='200'){
                            this.menuList =res.result
 
                        }else{
                            this.$alert(res.result, '提示', {
                                confirmButtonText: '确定',
                                showClose:false,
                                type:'info'
                            })
                        }
                    })
                })
            },
            //加载菜单流程
            async loadMenuFlow(formId) {
                try {
                    const flowData = await menuFlowDefineService.getMenuFlowData(formId)
            
                    if (flowData && flowData.nodes && flowData.nodes.length > 0) {
                        //console.log(JSON.stringify(flowData))
                        this.flowData = flowData
                    } else {
                        this.flowData = { nodes: [], edges: [] }
                    }
                } catch (error) {
                    this.flowData = { nodes: [], edges: [] }
                }
            },
            handleNodeClick(nodeData) {
                console.log('节点点击:', nodeData)
        
                // 只有表单节点（有 menuUrl）才跳转
                if (nodeData.menuUrl && nodeData.menuUrl.trim()) {
                    console.log('跳转到:', nodeData.menuUrl)
        
                // 使用 Vue Router 跳转
                this.$router.push(nodeData.menuUrl).catch(err => {
                    // 如果路由不存在，显示提示
                    if (err.name === 'NavigationDuplicated' || err.message.includes('Avoided redundant navigation')) {
                        // 已经在当前路由，忽略错误
                        console.log('已在当前页面')
                    } else {
                        this.$message.warning('菜单路径不存在: ' + nodeData.menuUrl)
                    }
                })
                } else {
                    // 模块节点没有 URL，提示用户
                    this.$message.info('该节点没有配置菜单路径')
                }
            },
        }
    }
</script>
<style scoped lang="less">
    /* 流程图组件 100% 填充 */
    ::v-deep .fullscreen-dialog .flow-chart-readonly,
    ::v-deep .fullscreen-dialog .SnakerFlowDesigner,
    ::v-deep .fullscreen-dialog .SnakerFlowDesigner > div {
        width: 100% !important;
        height: 100% !important;
        flex: 1;
        min-height: 0;
    }
   .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
 
</style>
<style lang="less">
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>